export const genderOptions = [
  {val: 0, label: 'Male'},
  {val: 1, label: 'Female'},
];
